import script from "./ArticlePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePage.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePage.vue?vue&type=style&index=0&id=2a547470&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a547470"]])

export default __exports__